import React from 'react'
import '../../css/pages/Contact.css'
import { useTranslation } from 'react-i18next';
import { OrderForm } from '../visualComponent/OrderForm';

export const Contact = () => {
    const telephoneNumber = " +358 40 563 2912"

    const { t } = useTranslation("global");
    return (
        <>
            <section id='contact-section' className='contact-section'>
                <div className='contact-section-text'>
                    <h2 className='contact-section-text-title'>{t('order_form.title')}</h2>
                    <p className='contact-section-text-description'>
                        {t('order_form.description')}
                        <a href="tel:+358 40 563 2912" className='contact-section-text-phone'>
                            {telephoneNumber}
                        </a>
                    </p>
                    <p className='contact-section-text-description-bottom'>
                        {t('order_form.description_bottom')}
                    </p>
                    <div className='contact-section-text-picture'></div>
                </div>
                <OrderForm />
            </section>
        </>
    )
}
